module.exports = __webpack_public_path__ + "static/media/mandacaru_thumb.77ca5deb.jpeg";